import { useAuthContext } from '../context';
import type { Permission } from '../permissions';

export function usePermission(key: Permission): boolean {
  const { state } = useAuthContext();
  return state.permissions.includes(key);
}

/** True when the user holds AT LEAST ONE of the keys (OR semantics), mirroring `@RequirePermission`. */
export function useHasAnyPermission(...keys: Permission[]): boolean {
  const { state } = useAuthContext();
  return keys.some((key) => state.permissions.includes(key));
}

export function usePermissions(...keys: Permission[]): Record<Permission, boolean> {
  const { state } = useAuthContext();
  const result = {} as Record<Permission, boolean>;
  for (const key of keys) {
    result[key] = state.permissions.includes(key);
  }
  return result;
}
